import React from 'react';
import { withRouter } from 'react-router';
import { withApollo } from "react-apollo";

import { notes } from '../../graphql/queries';
import { deleteNote } from '../../graphql/mutations';

class NoteDelete extends React.Component {

	constructor(props) {
		super(props);

		this.state = {
			id: props.id
		};

    	this.handleClick = this.handleClick.bind(this);
	}

	handleClick(e) {

		if(window.confirm('Delete Note?')) {
			this.props.client.mutate({
				mutation: deleteNote,
				variables: { id: this.state.id },
				refetchQueries: [{query: notes}]
			})
			.then(res => {
				this.props.history.replace('/notes/');
			});
		}
	}
	
	render() {
		return (
      		<button className="col__action col__action--danger" 
      			onClick={this.handleClick}>delete</button>
      	)
	}
}

export default withRouter(withApollo(NoteDelete))


// WEBPACK FOOTER //
// ./src/components/note/NoteDelete.js